'use es6';

import { Component, createContext, useContext, useState } from 'react';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
export const DialogContext = /*#__PURE__*/createContext();
export const DialogProvider = ({
  children
}) => {
  const [openDialogs, setOpenDialogs] = useState([]);
  return /*#__PURE__*/_jsx(DialogContext.Provider, {
    value: {
      openDialogs,
      showDialog: ({
        dialogType,
        dialogProps
      }) => {
        if (openDialogs.some(dialog => dialog.dialogType === dialogType)) {
          console.error('Dialog already open, was this a mistake?', dialogType);
          Raven.capturePageEvent('RAC_MultipleDialogOpens');
        }
        setOpenDialogs(openDialogs.concat({
          dialogType,
          dialogProps
        }));
      },
      hideDialog: () => {
        setOpenDialogs(openDialogs.slice(0, -1));
      }
    },
    children: children
  });
};
const createComponentDisplayName = _Component => {
  if (typeof _Component === 'string') {
    return _Component;
  }
  if (!_Component) {
    return undefined;
  }
  return _Component.displayName || _Component.name || 'Component';
};

/**
 * Connects class-components by passing a callback function (via prop) to show a dialog
 * @param Subject - the component to receive the callback
 */
export const withDialog = Subject => {
  var _class;
  return _class = class Decorated extends Component {
    constructor(...args) {
      super(...args);
      this.render = () => {
        return /*#__PURE__*/_jsx(DialogContext.Consumer, {
          children: ({
            showDialog
          }) => {
            if (!showDialog) {
              throw new Error(`Could not find context \`DialogContext\`. Did you forget to provide the context using \`DialogProvider\`?`);
            }
            return /*#__PURE__*/_jsx(Subject, Object.assign({
              showDialog: showDialog
            }, this.props));
          }
        });
      };
    }
  }, _class.displayName = createComponentDisplayName('withDialog', Subject), _class;
};
export const useDialogState = () => {
  const dialogState = useContext(DialogContext);
  if (!dialogState) {
    throw new Error(`Could not find context \`DialogContext\`. Did you forget to provide the context using \`DialogProvider\`?`);
  }
  return dialogState;
};